/* eslint-disable react/prop-types */
import { Box, Button, Divider, Paper, Stack, TableContainer, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Link from 'next/link';
import { useDispatch, useSelector } from 'react-redux';
import { GoogleBannerAds } from '../../components/GoogleAds';
import Iconify from '../../components/Iconify';
import { removeExams, setExamSituation } from '../../redux/slices/gplx.exam.slice';

export default function ExamResultSection() {
  const { exam } = useSelector((state) => state.examS);
  const total = exam?.examSituations.map(item => item.score || 0).reduce((a, b) => a + b, 0);
  const dispatch = useDispatch();

  const reset = () => {
    dispatch(removeExams(exam));
  };

  return (
    <Stack>
      <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5} sx={{ border: 0.1, borderColor: "grey", borderRadius: 1 }}>
        <Iconify icon={'wpf:statistics'} />
        <Typography variant="subtitle1" p={1}> KẾT QUẢ</Typography>
      </Stack >
      <Stack mt={1} p={1} spacing={1} sx={{ border: 0.1, borderColor: "grey", borderRadius: 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
          <Iconify icon={'mdi:question-mark-rhombus-outline'} />
          <Typography variant="body1" px={1} >Số tình huống:</Typography>
          <Typography variant="subtitle1" >{exam?.examSituations.length} </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
          <Iconify icon={'material-symbols:check-circle-outline'} />
          <Typography variant="body1" px={1} >Điểm:</Typography>
          <Typography variant="subtitle1" color={total >= 35 ? "green" : "red"} >{total} </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center" }} >
          <Iconify icon={'ic:sharp-sync-alt'} />
          <Typography variant="body1" px={1} >Trạng thái:</Typography>
          <Typography variant="subtitle1" color={total >= 35 ? "green" : "red"}>{exam?.status} </Typography>
        </Box>
        {exam?.status === "Kết thúc" && <>
          <Divider />
          {total >= 35 ?
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "center", py: 1.2, backgroundColor: '#ccffd7' }} >
              <Iconify icon={'solar:smile-circle-linear'} sx={{ color: 'green' }} />
              <Typography variant="subtitle1" color={"primary"} px={1} textAlign={"center"}>ĐÃ ĐẠT</Typography>
            </Box> :
            <Box sx={{
              display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "center", py: 1.2, backgroundColor: '#ffdcdc'
            }} >
              <Iconify icon={'ri:emotion-sad-line'} sx={{ color: 'red' }} />
              <Typography variant="subtitle1" color={"error"} px={1} textAlign={"center"}>ĐÃ TRƯỢT</Typography>
            </Box>}
          <Stack direction={"row"} spacing={1} pt={1}>
            <Button onClick={reset} variant={"outlined"} fullWidth size="large" startIcon={<Iconify icon={'ic:outline-sync'} />}>THI LẠI</Button>
            <Link href={"/thi-tinh-huong/thi-thu"} passHref><Button fullWidth variant={"contained"} size="large">ĐỀ KHÁC</Button></Link>
          </Stack>
        </>}
      </Stack >
      <Stack mt={1} spacing={2}>
        <SituationItem />
        <GoogleBannerAds />
      </Stack>
    </Stack >
  );
}

function SituationItem() {
  const dispatch = useDispatch();
  const { exam, examSituation } = useSelector((state) => state.examS);

  const review = (item) => {
    dispatch(setExamSituation(item));
  };

  return (
    <TableContainer component={Paper}>
      <Table size="medium" >
        <TableHead >
          <TableRow sx={{ borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid' }}>
            <TableCell sx={{ px: 0 }} >Câu hỏi</TableCell>
            <TableCell sx={{ px: 0 }}>Gắn cờ</TableCell>
            <TableCell sx={{ px: 0 }} colSpan={2}>Điểm </TableCell>
          </TableRow>
        </TableHead>
        <TableBody >
          {exam?.examSituations.map((item) => (
            <TableRow key={item.id} sx={{ borderWidth: 1, borderColor: '#ccc', borderStyle: 'solid' }}>
              <TableCell sx={{ px: 0, py: 1.2 }}><Typography variant='subtitle2'>Câu  {item.orderNo}</Typography></TableCell>
              {item.isAnswered
                ? <TableCell sx={{ px: 0, py: 1.2 }}>
                  <Typography variant='body2' sx={{ fontWeight: 500 }}> {(Math.round(item.seletedTime * 10) / 10)}s</Typography>
                </TableCell>
                : (item.id === examSituation?.id && exam?.status === "Đang thi" ? <TableCell sx={{ px: 0, py: 1.2 }}>
                  <Typography variant='body2' >Đang làm</Typography>
                </TableCell>
                  : (item.orderNo <= examSituation?.orderNo) ? <TableCell sx={{ px: 0, py: 1.2 }}>
                    <Typography variant='body2' color={"red"}>Bỏ qua</Typography>
                  </TableCell>
                    : (exam?.status === "Kết thúc") ? <TableCell sx={{ px: 0, py: 1.2 }}>
                      <Typography variant='body2' color={"red"}>Bỏ qua</Typography>
                    </TableCell>
                      : <TableCell sx={{ px: 0 }} />
                )}
              {item.isAnswered
                ? <TableCell sx={{ px: 0, py: 1.2 }} >
                  <Typography variant='subtitle2'>{item.score}</Typography>
                </TableCell>
                : (item.orderNo <= examSituation?.orderNo) ? <TableCell sx={{ px: 0, py: 1.2 }} >
                  <Typography variant='subtitle2'>0</Typography>
                </TableCell>
                  : (exam?.status === "Kết thúc") ? <TableCell sx={{ px: 0, py: 1.2 }} >
                    <Typography variant='subtitle2' >0</Typography>
                  </TableCell>
                    : <TableCell sx={{ px: 0, py: 1.2 }} />
              }
              {exam?.status === "Kết thúc" && <TableCell sx={{ px: 0, py: 1.2 }} align='right'>
                <Button size='small' variant="text" sx={{ m: 0, p: 0 }} onClick={() => { review(item); }} > Xem lại </Button>
              </TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
